import { useState, useCallback } from "react";
import { useScopeId } from "@core/hooks/useRouteParamId";
import { FinanceAllocationRuleKpi } from "@features/admin/finance/allocation-rule/types/financeAllocationRule";
import { fetchAllocationRuleKpisAsync } from "@features/admin/finance/allocation-rule/services/financeAllocationRuleSvc";

export function useFinanceAllocationRuleOptions() {
    const resolvedNationId = useScopeId() ?? 0;

    const [kpis, setKpis] = useState<FinanceAllocationRuleKpi[]>([]);
    const [kpisLoading, setKpisLoading] = useState(false);
    const [kpisError, setKpisError] = useState<string | null>(null);

    const fetchKpis = useCallback(async () => {
        let cancelled = false;
        setKpisLoading(true);
        setKpisError(null);
        try {
            const response = await fetchAllocationRuleKpisAsync(resolvedNationId);
            if (!cancelled) {
                setKpis(response.getData() ?? []);
            }
        } catch (e: any) {
            if (!cancelled) {
                setKpisError(e?.message ?? "Failed to load KPIs.");
            }
        } finally {
            if (!cancelled) {
                setKpisLoading(false);
            }
        }
        return () => { cancelled = true; };
    }, [resolvedNationId]);

    return { kpis, kpisLoading, kpisError, fetchKpis };
}
